import http from "./http";
var baseUrl = "/finance-web";


/**
 * 销项发票接口
 * */
/**
 * 获取销项发票列表
 * */
const getSalesInvoiceService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/outputBill/approve/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 获取项目部列表
 * */
const getDeptListService = () => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/queryAllProjectDept", {}, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 获取项目列表
 * */
const getProjectListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/queryProjectListByDeptId", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 新建提报单
const setApproveService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/outputBill/approve', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询当前审批流
const queryCurrentApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/bill/approve/queryCurrentApproveProcess", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//提交审批
const submitApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/bill/approve/submitApproveProcess', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询销项发票详情
const getApproveDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/outputBill/approve/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 根据项目ID查询项目地址
const getProjectAddressService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/queryContractByProjectId", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//批量更新发票
const invoiceBatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/outputBill/batch', params.outputBillList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 查询确认收款列表
const getReceiptsListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/outputBill/receipts/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 查询收款详情期数列表
const getReceiptsSItemsListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/receipts/items/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询确认收款详情
const getOutputBillDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/outputBill/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//获取临时下载地址
const getTempUrlService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/oss/getTempUrl', params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 查询收款期数列表
const getReceiptsItemsListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/receipts/items/outputBill/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//发票确认收款
const receiptsService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/outputBill/receipts', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


// 查询收款期数列表
const querySumListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/outputBill/sum/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出销项发票申请
 * */
const approveExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/outputBill/approve/list/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出销项发票确认收款
 * */
const receiptsExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/outputBill/receipts/list/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出销项发票确认收款
 * */
const sumExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/outputBill/sum/list/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/**
 * 进项发票接口
 * */
/**
 * 获取进项发票列表
 * */
const getIncomeInvoiceService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/inputBill/list/web", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 根据项目id获取分包信息
 * */
const querySubInfoByProjectIdService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sub/contract/querySubInfoByProjectId", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 进项发票提交申请
 * */
const getInputBillService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + '/inputBill', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 进项发票提交申请
 * */
const submitInputBillService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 进项发票修改
 * */
const putInputBillService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl + '/inputBill', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 进项发票提交审批流程
 * */
const inputBillApproveSubmitService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/approve/submit', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 进项发票导出
 * */
const exportInputBillService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询审批集合列表
 * */
const getApproveListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + "/inputBill/approve/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询审批集合详情
 * */
const getIncomeApproveDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + "/inputBill/approve/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询审批流列表
 * */
const getInvoiceApproveListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/common-web/approve/queryApproveProcess", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 审批合集导出
 * */
const exportApproveListService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/approve/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询发票认领列表
 * */
const getIncomeClaimListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/inputBill/claim/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 匹配导入发票
 * */
const claimAutoMatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/claim/autoMatch', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 手动认领发票
 * */
const claimConfirmService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/claim/confirm', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 取消手动认领发票
 * */
const claimCancelService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/claim/cancel', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出认领发票
 * */
const claimExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/claim/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询发票认领详情
 * */
const getClaimDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/inputBill/claim/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询进项发票统计列表
 * */
const getAnalysisListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/inputBill/analysis", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出认领发票
 * */
const analysisExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/analysis/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询用户列表
 * */
const getRoleListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/role", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询小程序菜单列表
 * */
const getMenuListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/menu", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询用户菜单权限
 * */
const getPermissionListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/appuser-web/role/menu/permission/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 发票认领进项税额
 * */
const getTaxAnalysisListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/inputBill/claim/taxAnalysis", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出发票认领进项税额
 * */
const claimTaxAnalysisExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/inputBill/claim/taxAnalysis/export', params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
export {
    getSalesInvoiceService,
    getDeptListService,
    getProjectListService,
    setApproveService,
    queryCurrentApproveProcessService,
    submitApproveProcessService,
    getApproveDetailService,
    getProjectAddressService,
    invoiceBatchService,
    getReceiptsListService,
    getReceiptsSItemsListService,
    getOutputBillDetailService,
    getTempUrlService,
    getReceiptsItemsListService,
    receiptsService,
    querySumListService,
    approveExportService,
    receiptsExportService,
    sumExportService,


    getIncomeInvoiceService,
    querySubInfoByProjectIdService,
    getInputBillService,
    submitInputBillService,
    putInputBillService,
    inputBillApproveSubmitService,
    exportInputBillService,
    getApproveListService,
    getIncomeApproveDetailService,
    getInvoiceApproveListService,
    exportApproveListService,
    getIncomeClaimListService,
    claimAutoMatchService,
    claimConfirmService,
    claimCancelService,
    claimExportService,
    getClaimDetailService,
    getAnalysisListService,
    analysisExportService,


    getRoleListService,
    getMenuListService,
    getPermissionListService,

    getTaxAnalysisListService,
    claimTaxAnalysisExportService,
}
